/* eslint-disable */
import ItalianDictionary from "../localization/it-it";
import DewTranslator from "../localization/translator";
import Utils from "../utils.js";
import Vue from "vue";
import Vuex from "vuex";
let ut = new Utils();
Vue.use(Vuex);
//init store
const store = new Vuex.Store({
  state: {
    currentTranslator: new DewTranslator(new ItalianDictionary()),
    currentToken: null,
    adminToken: null,
    userShops: [],
    isFullscreen: false,
    modifying: false
    // fakeUser: ut.getCookie("sam_fisher"),
    // fakeUserName: ut.getCookie("sam_fisher_name")
  },
  getters: {
    shopState: (state, getters) =>
      getters.myShop !== null ? getters.myShop.state : 1,
    myShop: state => (state.userShops.length > 0 ? state.userShops[0] : null),
    // fakeUser: state => state.fakeUser,
    // fakeUserName: state => state.fakeUserName,
    isLogged: state => state.currentToken !== null,
    token: state => state.currentToken,
    tokenObject: (state, getters) =>
      state.currentToken !== null
        ? JSON.parse(getters.b64Conv(state.currentToken.split(".")[1]))
        : null,
    tokenHeader: state =>
      state.currentToken !== null
        ? { Authorization: "Bearer " + state.currentToken }
        : {},
    isFakeUser: function(state, getters) {
      const adminTokenLS = window.localStorage.getItem("_old_token", null);
      state.adminToken = adminTokenLS
      const adminToken = state.adminToken;
      if (adminToken) return true;
      else return false;
    },
    isAdmin: function(state, getters) {
      if (state.currentToken !== null) return getters.hasDlc("V13");
      else return false;
    },
    hasDlc: (state, getters) => dlc => {
      if (getters.tokenObject !== null) {
        let temp = getters.tokenObject;
        for (let i in temp.Claims) {
          if (temp.Claims[i] === dlc) return true;
        }

        return false;
      }
    },
    b64Conv: (state, getters) => str => {
      return decodeURIComponent(
        Array.prototype.map
          .call(atob(str), function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    }
  },
  mutations: {
    setfakeUser: function(state, val) {
      if (val) {
        const adminToken = state.currentToken;
        state.currentToken = val;
        state.adminToken = adminToken
        window.localStorage.setItem("_old_token", adminToken);
        window.localStorage.setItem("_rccarriage_5t_puorcnfam", val);
      }
      else
      {
        const adminToken = window.localStorage.getItem("_old_token", null);
        window.localStorage.removeItem("_old_token");
        state.adminToken = null
        state.currentToken = adminToken;
        window.localStorage.setItem("_rccarriage_5t_puorcnfam", adminToken);
      }
      //  state.fakeUser = val
    },
    // fakeUserName: function(state, val) {
    //   state.fakeUserName = val
    // },
    setUserShops: function(state, val) {
      state.userShops = val;
    },
    isModifying: function(state) {
      if (!state.modifying) state.modifying = true;
    },
    notIsModifying: function(state) {
      if (state.modifying) state.modifying = false;
    },
    toggleFullscreen: function(state) {
      state.isFullscreen = !state.isFullscreen;
    },
    changeLanguage: function(state, dictionary) {
      state.currentTranslator = dictionary;
    },
    setToken: function(state, newToken) {
      state.currentToken = newToken;
      window.localStorage.setItem("_rccarriage_5t_puorcnfam", newToken);
    },
    resetToken: function(state) {
      state.currentToken = null;
      window.localStorage.removeItem("_old_token");
      window.localStorage.removeItem("_rccarriage_5t_puorcnfam");
      // document.cookie = "sam_fisher" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      // document.cookie = "sam_fisher_name" + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
      // state.fakeUserName = null;
      // state.fakeUserName = "";
    },
    loadToken: function(state) {
      var token = window.localStorage.getItem("_rccarriage_5t_puorcnfam");
      state.currentToken = token;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js